import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE, FIELD_SPACE_XS,
  FORM_INNER_WIDE_MAX_WIDTH,
  FORM_INNER_X_WIDE_MAX_WIDTH, FORM_WIDE_MAX_WIDTH,
  IMAGE_BORDER_RADIUS,
  VIEW_BESIDE_PREVIEW_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import Space from "../commons/Space";
import {FormControl, FormLabel, IconButton, Typography} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import ValueHelper, {getInitialFiles, textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import constants from "../../constants";
import FileHelper from "../../utils/FileHelper";
import {cloneDeep} from "lodash";
import InputLabel from "@material-ui/core/InputLabel";
import SingleFilePicker, {
  ACCEPTED_AUDIO_MIMES,
  ACCEPTED_IMAGE_MIMES,
  AUDIO_MAX_SIZE,
  FILE_TYPE_AUDIO,
  FILE_TYPE_IMAGE,
  IMAGE_MAX_SIZE,
  IMAGE_MAX_WIDTH_HEIGHT,
  IMAGE_PROFILE_MAX_WIDTH_HEIGHT,
} from "../commons/SingleFilePicker";
import {ColorActivityFormImage, ColorFieldBorder, ColorTheme} from "src/styles/Colors";
import FormSectionHeaderView from "../commons/FormSectionHeaderView";
import {
  ACTIVITY_TYPE_BETTING_PIC,
  ACTIVITY_TYPE_BRAND_RACE,
  ACTIVITY_TYPE_COLLECT_STARS,
  ACTIVITY_TYPE_EXTERNAL_GAMES,
  ACTIVITY_TYPE_FIND_HIDDEN,
  ACTIVITY_TYPE_FLIP_CARD,
  ACTIVITY_TYPE_GAME_ROULETTE,
  ACTIVITY_TYPE_GREEDY_SPIN,
  ACTIVITY_TYPE_GUESS,
  ACTIVITY_TYPE_IDENTIFY_LOCATION,
  ACTIVITY_TYPE_MATCH_THREE,
  ACTIVITY_TYPE_MATCHING_PIC,
  ACTIVITY_TYPE_POKER,
  ACTIVITY_TYPE_PREDICTION,
  ACTIVITY_TYPE_PUZZLE,
  ACTIVITY_TYPE_PUZZLE_SLIDE,
  ACTIVITY_TYPE_QUESTION,
  ACTIVITY_TYPE_QUESTIONNAIRE, ACTIVITY_TYPE_SLIDES,
  ACTIVITY_TYPE_SLOT,
  ACTIVITY_TYPE_SPIN_DISCOVER,
  ACTIVITY_TYPE_SURVEY,
  ACTIVITY_TYPE_TIC_TAC_TOE,
  ACTIVITY_TYPE_VISITOR_OPINION,
  ACTIVITY_TYPE_WHAC_A_MOLE
} from "../../constants/ApiConstants";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ApiHelper from "../../utils/ApiHelper";
import DateTimeHelper from "../../utils/DateTimeHelper";
import {DateTimePicker, MuiPickersUtilsProvider, TimePicker} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import SectionHeaderView, {
  SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE
} from "src/js/components/commons/SectionHeaderView";
import FieldSpace from "src/js/components/commons/FieldSpace";
import Switch from "@material-ui/core/Switch";
import {SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";
import {ChromePicker} from 'react-color';
import tinycolor from "tinycolor2";
import FullWidthDummyView from "src/js/components/commons/FullWidthDummyView";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import CancelIcon from '@material-ui/icons/Cancel';
import FormHelperText from "@material-ui/core/FormHelperText";

const SPACE_IMAGE = 16;
const SPACE_IMAGE_XS = 13;


const useStyles = (theme) => ({
  videoPreview: {
    borderRadius: BORDER_RADIUS,
    border: '5px solid '+ ColorTheme,
    marginLeft: 32,
    marginRight: 32,
    // marginBottom: 2 * FIELD_SPACE,
    width: 320,
    height: 640,
    [theme.breakpoints.down('md')]: {
      width: 280,
      height: 560,
    }
  },
  imageCustomise: {
    borderRadius: BORDER_RADIUS,
    overflow: 'hidden',
    padding: 8,
    border: '1px solid rgba(0,0,0,0.03)',
    backgroundColor: ColorActivityFormImage,
    minWidth: 260,
    width: '100%',
    marginBottom: 16
  },
  imageCustomisePlaceholderImage: {
    width: 48,
    height: 48,
    borderRadius: IMAGE_BORDER_RADIUS,
  },
  imageCustomisePlaceholderIcon: {
    width: 48,
    height: 48,
    borderRadius: BORDER_RADIUS,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageCustomise1: {
    overflow: 'hidden',
  },
});

const CHALLENGE_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.random'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.topViewed'/>},
  {'id': 2, 'name': <FormattedMessage id='activity.manage.winnersBy.topLiked'/>},
  {'id': 3, 'name': <FormattedMessage id='activity.manage.winnersBy.downloadedOnly'/>},
];

const LAZY_WIN_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.topCollectors'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.moreThanValue'/>, 'showWinnersByValue': true},
];

const QUESTIONNAIRE_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.questionnaire.top'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.questionnaire.moreThanValue'/>, 'showWinnersByValue': true},
];

const IDENTIFY_LOCATION_FUN_WINNERS_BY = [
  {'id': 0, 'name': <FormattedMessage id='activity.manage.winnersBy.identifyLocation.nearest'/>},
  {'id': 1, 'name': <FormattedMessage id='activity.manage.winnersBy.identifyLocation.lessThanValue'/>, 'showWinnersByValue': true},
];

class ManageActivityCustomization extends React.Component {

  constructor(props) {
    super(props);
    const {activityData} = this.props;
    this.key = 0;

    this.maxGamePlayAudioDuration = 10*1000;
    this.maxBgAudioDuration = 60;
    if (activityData.mediaConfigs) {
      this.maxGamePlayAudioDuration = activityData.mediaConfigs.maxGamePlayAudioDuration;
      this.maxBgAudioDuration = activityData.mediaConfigs.maxBgAudioDuration;
    }
    this.slotMinValues = 0;
    this.slotMaxValues = 0;
    this.slotMinImages = 0;
    this.slotMaxImages = 0;
    this.slotTotalImages = 0;
    this.maxWinOffersCount = 0;
    if (activityData.activityConfigs) {
      this.slotMinValues = activityData.activityConfigs.slotMinValues;
      this.slotMaxValues = activityData.activityConfigs.slotMaxValues;
      this.slotMinImages = activityData.activityConfigs.slotMinImages;
      this.slotMaxImages = activityData.activityConfigs.slotMaxImages;
      this.slotTotalImages = activityData.activityConfigs.slotTotalImages;
      this.maxWinOffersCount = activityData.activityConfigs.maxWinOffersCount;
    }

    this.dateMax = DateTimeHelper.getDateAfterYearsFromNow(1);
    this.dateNow = DateTimeHelper.getDateBeforeMinutesFromNow(30);

    let contentTypeText = false;
    let contentTypeImage = false;
    let contentTypeAudio = false;
    let contentTypeVideo = false;
    if (activityData.contentTypes && (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT)) {
      activityData.contentTypes.forEach((value) => {
        if (value == '1') {
          contentTypeText = true;
        } else if (value == '2') {
          contentTypeImage = true;
        } else if (value == '3') {
          contentTypeAudio = true;
        } else if (value == '4') {
          contentTypeVideo = true;
        }
      });
    }

    this.winnersByOptions = LAZY_WIN_FUN_WINNERS_BY;
    if (activityData.type === constants.activity.types.CHALLENGE || activityData.type === constants.activity.types.SOCIAL_CONTENT) {
      this.winnersByOptions = CHALLENGE_WINNERS_BY;
    } else if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      this.winnersByOptions = QUESTIONNAIRE_FUN_WINNERS_BY;
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      this.winnersByOptions = IDENTIFY_LOCATION_FUN_WINNERS_BY;
    }

    let winnersBySelected = null;
    this.winnersByOptions.forEach((typeObj) => {
      if (activityData.winnersBy == typeObj.id) {
        winnersBySelected = typeObj;
      }
    });
    if (!winnersBySelected) {
      winnersBySelected = this.winnersByOptions[0];
    }

    let value1PlaceholderAr = activityData.value1PlaceholderAr;
    if (!value1PlaceholderAr && activityData.type === constants.activity.types.PREDICTION) {
      value1PlaceholderAr = activityData.value2Placeholder;
    }

    this.slotValues = [];
    if (activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GUESS
      || activityData.type === constants.activity.types.QUESTION
      || activityData.type === constants.activity.types.QUESTIONNAIRE
      || activityData.type === constants.activity.types.SURVEY
      || activityData.type === constants.activity.types.SOCIAL_CONTENT
      || activityData.type === constants.activity.types.CHALLENGE
      || activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.VISITOR_OPINION
      || activityData.type === constants.activity.types.EXTERNAL_GAMES
    ) {
      if (!activityData.slotValues) {
        activityData.slotValues = [];
      }
      activityData.slotValues.forEach((slotValue) => {
        const option = cloneDeep(slotValue);
        if (!option.imageUrl) {
          option.imageUrl = ApiHelper.getSlotDefaultImageUrl(activityData, slotValue.number);
        }
        option.initialFiles = getInitialFiles(option.imageFiles, option.imageUrl, FILE_TYPE_IMAGE);
        this.slotValues.push(option);
      });
    }
    let imageUrl1 = activityData.imageUrl1;
    let imageUrl2 = activityData.imageUrl2;
    if (!imageUrl1) {
      if (activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
        || activityData.type === constants.activity.types.GAME_FLIP_CARD
        || activityData.type === constants.activity.types.GAME_PUZZLE
        || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
        || activityData.type === constants.activity.types.GAME_POKER) {
        imageUrl1 = ApiHelper.getSlotDefaultCardImageUrl(activityData.type);
      }
    }
    if (!imageUrl2) {
      if (activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
        imageUrl2 = ApiHelper.getSlotDefaultCardRevealImageUrl();
      }
    }

    let hourStartAt = null;
    let hourEndAt = null;
    let consumableWSunday = false;
    let consumableWMonday = false;
    let consumableWTuesday = false;
    let consumableWWednesday = false;
    let consumableWThursday = false;
    let consumableWFriday = false;
    let consumableWSaturday = false;
    if (activityData.type === constants.activity.types.SHOWCASE_MENU) {
      if (activityData.hourStartAt) {
        hourStartAt = activityData.hourStartAt instanceof Date ? activityData.hourStartAt : DateTimeHelper.getDateFromDateString(activityData.hourStartAt);
      }
      if (activityData.hourEndAt) {
        hourEndAt = activityData.hourEndAt instanceof Date ? activityData.hourEndAt : DateTimeHelper.getDateFromDateString(activityData.hourEndAt);
      }
      if (!activityData.consumableWDays) {
        activityData.consumableWDays = [1,2,3,4,5,6,7];
      }
      activityData.consumableWDays.forEach((value) => {
        if (value == '1') {
          consumableWSunday = true;
        } else if (value == '2') {
          consumableWMonday = true;
        } else if (value == '3') {
          consumableWTuesday = true;
        } else if (value == '4') {
          consumableWWednesday = true;
        } else if (value == '5') {
          consumableWThursday = true;
        } else if (value == '6') {
          consumableWFriday = true;
        } else if (value == '7') {
          consumableWSaturday = true;
        }
      });
    }

    const endAtA = activityData.type === constants.activity.types.PREDICTION && activityData.endAtA ? activityData.endAtA : activityData.endAt;
    const latitude = activityData.rightOptionHint ? parseFloat(activityData.rightOptionHint) : null;
    const longitude = activityData.rightOptionHintAr ? parseFloat(activityData.rightOptionHintAr) : null;

    this.state = {
      sections: [
        {id: 1, labelId: 'activity.correctAnswer', subLabelId: 'activity.correctAnswerHint', expand: true, expandAlways: true},
        {id: 2, labelId: 'activity.correctLocation', subLabelId: 'activity.correctLocationHint', expand: true, expandAlways: true},
      ],
      showAnswers: activityData.showAnswers == true,
      correction: activityData.correction == true,
      gameTime: activityData.gameTime / 1000,
      winnersByValue: activityData.winnersByValue,
      startAt: activityData.startAt instanceof Date ? activityData.startAt : DateTimeHelper.getDateFromDateString(activityData.startAt),
      endAt: activityData.endAt instanceof Date ? activityData.endAt : DateTimeHelper.getDateFromDateString(activityData.endAt),
      endAtA: endAtA instanceof Date ? endAtA : DateTimeHelper.getDateFromDateString(endAtA),
      themeColor: activityData.themeColor || (activityData.gameInfo ? activityData.gameInfo.themeColor : '#'+ tinycolor(ColorTheme).toHex()),

      feedbackHint: activityData.feedbackHint || '',
      clickLimit: activityData.clickLimit && activityData.clickLimit != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.clickLimit : '',
      isGamePuzzleSubTypeTap: activityData.subType == 1,
      videoFromGallery: activityData.consumableAt == 1,
      flipsNeeded: activityData.flipsNeeded || '0',
      deadCount: activityData.deadCount || '0',
      gameColumns: activityData.gameColumns || '',
      gameRows: activityData.gameRows || '',
      gameSColumns: activityData.gameSColumns || '',
      resetGameDays: activityData.consumeLimitPerDay || '',
      resetLimitPerUser: activityData.resetLimitPerUser != constants.activity.VALUE_DEFAULT_MAX ? ''+ activityData.resetLimitPerUser : '',
      contactNumber: activityData.feedbackHint || '',
      winnersBySelected: winnersBySelected,
      qTitle: activityData.qTitle || '',
      qTitleAr: activityData.qTitleAr || '',
      value1Placeholder: activityData.value1Placeholder || '',
      value1PlaceholderAr: value1PlaceholderAr || '',
      rightOptionHint: activityData.rightOptionHint || '',
      rightOptionHintAr: activityData.rightOptionHintAr || '',
      latitude: latitude,
      longitude: longitude,
      contentTypeText: contentTypeText,
      contentTypeImage: contentTypeImage,
      contentTypeAudio: contentTypeAudio,
      contentTypeVideo: contentTypeVideo,
      imageUrl1: imageUrl1,
      imageFiles1: activityData.imageFiles1,
      fileObjsImage1: activityData.fileObjsImage1,
      isImageDeleted1: activityData.isImageDeleted1,
      imageUrl2: imageUrl2,
      imageFiles2: activityData.imageFiles2,
      fileObjsImage2: activityData.fileObjsImage2,
      isImageDeleted2: activityData.isImageDeleted2,
      imageActionUrl: activityData.imageActionUrl,
      imageActionFiles: activityData.imageActionFiles,
      isImageActionDeleted: activityData.isImageActionDeleted,
      bgAudioUrl: activityData.bgAudioUrl,
      bgAudioFiles: activityData.bgAudioFiles,
      isBgAudioDeleted: activityData.isBgAudioDeleted,
      gamePlayAudioUrl: activityData.gamePlayAudioUrl,
      gamePlayAudioFiles: activityData.gamePlayAudioFiles,
      isGamePlayAudioDeleted: activityData.isGamePlayAudioDeleted,
      actionMessage: activityData.actionMessage,

      hourStartAt: hourStartAt,
      hourEndAt: hourEndAt,
      consumableWSunday: consumableWSunday,
      consumableWMonday: consumableWMonday,
      consumableWTuesday: consumableWTuesday,
      consumableWWednesday: consumableWWednesday,
      consumableWThursday: consumableWThursday,
      consumableWFriday: consumableWFriday,
      consumableWSaturday: consumableWSaturday,
      showcase: activityData.showcase,
      winPoints: activityData.winPoints || '0',
      winLimit: activityData.winLimit || '1',
      winILimit: activityData.winILimit || '0',
      activityRewarded: activityData.offer,
      activityRewardedSearch: activityData.offer ? activityData.offer.name : '',
      isActivityRewardedLoading: false,
      showValidationMsg: false,
      reload: false,
    };

    this.initialFiles1 = getInitialFiles(activityData.imageFiles1, imageUrl1, FILE_TYPE_IMAGE);
    this.initialFiles2 = getInitialFiles(activityData.imageFiles2, imageUrl2, FILE_TYPE_IMAGE);
    this.bgAudioInitialFiles = getInitialFiles(activityData.bgAudioFiles, activityData.bgAudioUrl, FILE_TYPE_AUDIO);
  }

  componentDidMount() {
    this.props.moveNextCallback(this);
  }

  componentWillUnmount() {
  }

  highlightErrors = () => {
    this.getData();
  }

  updateState(fields) {
    this.setState(fields, () => {
      this.props.onDataUpdated(this.getData(true));
    });
  }

  reloadView() {
    this.updateState({reload: !this.state.reload, showValidationMsg: false});
  }

  // addDummySlotValues() {
  //   const slotCount = this.slotValues ? this.slotValues.length : 0;
  //   if (!this.slotValues || slotCount < this.slotMaxValues) {
  //     if (!this.slotValues) {
  //       this.slotValues = [];
  //     }
  //     for (let i = 0; i < this.slotMaxValues - slotCount; i++) {
  //       const id = -(100 + i + 1);
  //       const imageUrl = APP_GAME_DEFAULT_IMAGES_URI + 'ic_slot' + id + '.png';
  //       this.slotValues.push({
  //         id: id,
  //         imageUrl: imageUrl,
  //         initialFiles: [],
  //         offers: [],
  //         points: '0',
  //         value1: '0',
  //         winLimit: '0',
  //         winILimit: '0',
  //       });
  //     }
  //   }
  // }

  getRandomWeightage() {
    return Math.max(10, Math.floor((Math.random() * 100)));
  }

  getData(excludeError) {
    const {activityData} = this.props;
    const {
      showAnswers,
      correction,
      gameTime,
      winnersByValue,
      startAt,
      endAt,
      endAtA,
      themeColor,

      feedbackHint,
      clickLimit,
      isGamePuzzleSubTypeTap,
      videoFromGallery,
      flipsNeeded,
      deadCount,
      gameColumns,
      gameRows,
      gameSColumns,
      resetGameDays,
      resetLimitPerUser,
      contactNumber,
      winnersBySelected,
      qTitle,
      qTitleAr,
      value1Placeholder,
      value1PlaceholderAr,
      rightOptionHint,
      rightOptionHintAr,
      contentTypeText,
      contentTypeImage,
      contentTypeAudio,
      contentTypeVideo,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioDeleted,
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      isImageDeleted1,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      isImageDeleted2,
      imageActionUrl,
      imageActionFiles,
      isImageActionDeleted,
      gamePlayAudioUrl,
      gamePlayAudioFiles,
      isGamePlayAudioDeleted,
      actionMessage,

      consumableWSunday,
      consumableWMonday,
      consumableWTuesday,
      consumableWWednesday,
      consumableWThursday,
      consumableWFriday,
      consumableWSaturday,
      hourStartAt,
      hourEndAt,
      showcase,
      winPoints,
      winLimit,
      winILimit,
      activityRewarded,
    } = this.state;

    const contentTypes = [];
    if (contentTypeText) {
      contentTypes.push('1');
    }
    if (contentTypeImage) {
      contentTypes.push('2');
    }
    if (contentTypeAudio) {
      contentTypes.push('3');
    }
    if (contentTypeVideo) {
      contentTypes.push('4');
    }
    const eGameRows = gameRows >= 2 && gameRows <= 6 ? gameRows : 3;
    const eGameColumns = gameColumns >= 2 && gameColumns <= 6 ? gameColumns : 3;
    const eGameSColumns = gameSColumns >= 2 && gameSColumns <= 6 ? gameSColumns : 3;

    const consumableWDays = [];
    if (consumableWSunday) {
      consumableWDays.push('1');
    }
    if (consumableWMonday) {
      consumableWDays.push('2');
    }
    if (consumableWTuesday) {
      consumableWDays.push('3');
    }
    if (consumableWWednesday) {
      consumableWDays.push('4');
    }
    if (consumableWThursday) {
      consumableWDays.push('5');
    }
    if (consumableWFriday) {
      consumableWDays.push('6');
    }
    if (consumableWSaturday) {
      consumableWDays.push('7');
    }

    if (!excludeError) {
      if (!startAt || (!activityData.noEditStartAt && !DateTimeHelper.isDateAfter(startAt, this.dateNow))) {
        this.updateState({showValidationMsg: true});
        return false;
      }
      if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
        if ((!winnersByValue && winnersByValue !== 0)
          || ValueHelper.getEnglishValue(winnersByValue) < 0
          || ValueHelper.getEnglishValue(winnersByValue) > activityData.questions.length) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      } else if (activityData.type === constants.activity.types.SHOWCASE_MENU) {
        if (consumableWDays.length === 0) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      } else if (activityData.type === constants.activity.types.PREDICTION) {
        if (!endAtA || !DateTimeHelper.isDateAfter(endAtA, startAt)) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      } else if (activityData.type === constants.activity.types.VISITOR_OPINION
        || activityData.type === constants.activity.types.EVENT
        || activityData.type === constants.activity.types.LIKE_USER) {

      } else {
        if (!this.isFieldImageUrl1Correct() || !this.isFieldImageUrl2Correct()) {
          this.updateState({showValidationMsg: true});
          return false;
        }
        if (activityData.type !== constants.activity.types.SLIDES
          && activityData.type !== constants.activity.types.SHOWCASE_MENU
          && this.isSlotsIncorrect()) {
          this.updateState({showValidationMsg: true});
          return false;
        }
      }
    }
    let eSlotValues = null;
    if (this.slotValues && this.slotValues.length > 0) {
      eSlotValues = [];
      let index = 0;
      this.slotValues.forEach((slotValue) => {
        // if (index < this.slotMaxValues || ((slotValue.imageUrl && !ApiHelper.isPublicAsset(slotValue.imageUrl)) || (slotValue.imageFiles && slotValue.imageFiles.length > 0) || slotValue.isImageDeleted)) {
          eSlotValues.push(slotValue);
        // }
        index++;
      });
    }
    // if (activityData.slotValues.length > eSlotValues.length) {
    //   for (let i = this.slotMaxValues; i < this.slotTotalImages; i++) {
    //     if (activityData.slotValues.length <= i) {
    //       break;
    //     }
    //     eSlotValues.push(activityData.slotValues[i]);
    //   }
    // }

    const eFeedbackHint = activityData.type === constants.activity.types.EVENT ? contactNumber : feedbackHint;
    const data = {
      showAnswers,
      correction,
      gameTime: gameTime * 1000,
      startAt,
      endAt,
      endAtA,
      themeColor,

      clickLimit,
      feedbackHint: eFeedbackHint,
      // subType: isGamePuzzleSubTypeTap ? 1 : 0,
      videoFromGallery,
      flipsNeeded,
      deadCount,
      gameColumns: eGameColumns,
      gameRows: eGameRows,
      gameSColumns: eGameSColumns,
      consumeLimitPerDay: resetGameDays,
      resetLimitPerUser,
      winnersBy: winnersBySelected ? winnersBySelected.id : 0,
      qTitle,
      qTitleAr,
      value1Placeholder,
      value1PlaceholderAr,
      rightOptionHint,
      rightOptionHintAr,
      // contentTypes,
      bgAudioUrl,
      bgAudioFiles,
      isBgAudioDeleted,
      imageUrl1,
      imageFiles1,
      fileObjsImage1,
      isImageDeleted1,
      imageUrl2,
      imageFiles2,
      fileObjsImage2,
      isImageDeleted2,
      imageActionUrl,
      imageActionFiles,
      isImageActionDeleted,
      gamePlayAudioUrl,
      gamePlayAudioFiles,
      isGamePlayAudioDeleted,
      actionMessage,

      showcase,
      winPoints,
      winLimit,
      winILimit,
      offer: activityRewarded,
    };
    if (activityData.type !== constants.activity.types.SLIDES && activityData.type !== constants.activity.types.SHOWCASE_MENU) {
      data.slotValues = eSlotValues;
    }
    if (activityData.type === constants.activity.types.SHOWCASE_MENU) {
      data.consumableWDays = consumableWDays;
      data.hourStartAt = hourStartAt;
      data.hourEndAt = hourEndAt;
    }
    if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      data.winnersBy = 1;
      data.winnersByValue = winnersByValue;
    }
    return data;
  }

  isFieldImageUrl1Correct() {
    return true;
  }

  isFieldImageUrl2Correct() {
    return true;
  }

  isFieldFlipNeededCorrect() {
    const {activityData} = this.props;
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.COLLECT_STARS
    ) {
      const {flipsNeeded} = this.state;
      return flipsNeeded && ValueHelper.getEnglishValue(flipsNeeded) > 0;
    }
    return true;
  }

  isFieldDeadCountCorrect() {
    const {activityData} = this.props;
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    ) {
      const {deadCount} = this.state;
      return deadCount && ValueHelper.getEnglishValue(deadCount) >= 0;
    }
    return true;
  }

  render() {
    const {
      showAnswers,
      correction,
      gameTime,
      winnersByValue,
      startAt,
      endAt,
      endAtA,

      isGamePuzzleSubTypeTap,
      videoFromGallery,
      flipsNeeded,
      deadCount,
      gameColumns,
      gameRows,
      gameSColumns,
      resetGameDays,
      resetLimitPerUser,
      contactNumber,
      winnersBySelected,
      qTitle,
      value1Placeholder,
      value1PlaceholderAr,
      rightOptionHint,
      rightOptionHintAr,
      latitude,
      longitude,
      consumableWSunday,
      consumableWMonday,
      consumableWTuesday,
      consumableWWednesday,
      consumableWThursday,
      consumableWFriday,
      consumableWSaturday,
      hourStartAt,
      hourEndAt,
      showcase,
      showValidationMsg,
    } = this.state;
    const {app, activities, activityData, canEnableShowcase, canAddBgAudio, classes, isXS} = this.props;

    // let flipsNeededTextKey = null;
    // let flipsNeededHintKey = null;
    // let deadCountTextKey = null;
    // if (activityData.type === constants.activity.types.COLLECT_STARS) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    // } else if (activityData.type === constants.activity.types.GAME_FIND_HIDDEN) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    //   deadCountTextKey = 'activity.manage.emptyCardsCount';
    // } else if (activityData.type === constants.activity.types.GAME_MATCH_PAIR) {
    //   flipsNeededTextKey = 'activity.manage.flipsCount';
    // } else if (activityData.type === constants.activity.types.GAME_MATCH_THREE) {
    //   flipsNeededTextKey = 'activity.manage.movesLimit';
    // } else if (activityData.type === constants.activity.types.GAME_PUZZLE) {
    //   flipsNeededTextKey = 'activity.manage.movesLimit';
    //   flipsNeededHintKey = 'activity.manage.hintPuzzleMovesCount';
    // } else {
    //   flipsNeededTextKey = 'activity.manage.flipsNeeded';
    //   deadCountTextKey = 'activity.manage.deadCardsCount';
    // }

    const showFeedback = activityData.type === constants.activity.types.VISITOR_OPINION;
    const showContactNumber = activityData.type === constants.activity.types.EVENT;
    const showParticipateLimit = activityData.type === constants.activity.types.EVENT;
    const showPredictionEndDate = activityData.type === constants.activity.types.PREDICTION;
    const showAnswerResult = activityData.type === constants.activity.types.QUESTION;
    const showValuePlaceholders = false;
    // const showValuePlaceholders = activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_BRAND_RACE;
    const showGameTime = false;
    // const showGameTime = activityData.type === constants.activity.types.GAME_FLIP_CARD
    //   || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //   || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE;
    const showGameWinnersBy = false;
    // const showGameWinnersBy = activityData.type === constants.activity.types.CHALLENGE
    //   || activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.COLLECT_STARS
    //   || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //   || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //   || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //   || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.IDENTIFY_LOCATION;

    let winnersByValuePlaceholderKey = null;
    if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
      winnersByValuePlaceholderKey = 'activity.manage.questionnaire.minCorrectAnsToWinEligible'
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      winnersByValuePlaceholderKey = 'activity.manage.identifyLocation.minKmsToWinEligible'
    } else {
      winnersByValuePlaceholderKey = 'activity.manage.minValueToWinEligible'
    }
    let predictionTitleKey = null;
    let predictionAnswer1Key = null;
    let predictionAnswer2Key = null;
    if (activityData.type === constants.activity.types.PREDICTION) {
      predictionTitleKey = 'activity.manage.predictionTitle';
      predictionAnswer1Key = 'activity.manage.predictionAnswer1';
      predictionAnswer2Key = 'activity.manage.predictionAnswer2';
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      predictionTitleKey = 'activity.manage.identifyLocationTitle';
      predictionAnswer1Key = 'activity.manage.predictionAnswer1';
      predictionAnswer2Key = 'activity.manage.predictionAnswer2';
    }
    let value1TextKey = null;
    let value2TextKey = null;
    let valueLength = 20;
    if (activityData.type === constants.activity.types.PREDICTION) {
      value1TextKey = 'activity.manage.predictionPlaceholder1';
      value2TextKey = 'activity.manage.predictionPlaceholder2';
      valueLength = 200;
    } else if (activityData.type === constants.activity.types.LIKE_USER) {
      value1TextKey = 'activity.manage.sharePlaceholderText';
      valueLength = 20;
    } else if (activityData.type === constants.activity.types.GAME_BRAND_RACE) {
      value1TextKey = 'activity.manage.brandPlaceholderText';
      valueLength = 20;
    } else {
      value1TextKey = 'activity.manage.scoreValuePlaceholder';
      valueLength = 20;
    }

    const hideBg = activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.JACKPOT
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE;

    // const hideSlot = activityData.type === constants.activity.types.LIKE_USER
    //   || activityData.type === constants.activity.types.CHALLENGE
    //   || activityData.type === constants.activity.types.PREDICTION
    //   || activityData.type === constants.activity.types.IDENTIFY_LOCATION
    //   || activityData.type === constants.activity.types.GUESS
    //   || activityData.type === constants.activity.types.QUESTIONNAIRE
    //   || activityData.type === constants.activity.types.GAME_PUZZLE;

    const showBgAudioPicker = canAddBgAudio && (activityData.type === ACTIVITY_TYPE_SLOT
        || activityData.type === ACTIVITY_TYPE_GREEDY_SPIN
        || activityData.type === ACTIVITY_TYPE_MATCHING_PIC
        || activityData.type === ACTIVITY_TYPE_FIND_HIDDEN
        || activityData.type === ACTIVITY_TYPE_FLIP_CARD
        || activityData.type === ACTIVITY_TYPE_PREDICTION
        || activityData.type === ACTIVITY_TYPE_SPIN_DISCOVER
        || activityData.type === ACTIVITY_TYPE_GAME_ROULETTE
        || activityData.type === ACTIVITY_TYPE_QUESTION
        || activityData.type === ACTIVITY_TYPE_BETTING_PIC
        || activityData.type === ACTIVITY_TYPE_COLLECT_STARS
        || activityData.type === ACTIVITY_TYPE_QUESTIONNAIRE
        || activityData.type === ACTIVITY_TYPE_SURVEY
        || activityData.type === ACTIVITY_TYPE_PUZZLE
        || activityData.type === ACTIVITY_TYPE_PUZZLE_SLIDE
        || activityData.type === ACTIVITY_TYPE_MATCH_THREE
        || activityData.type === ACTIVITY_TYPE_TIC_TAC_TOE
        || activityData.type === ACTIVITY_TYPE_WHAC_A_MOLE
        || activityData.type === ACTIVITY_TYPE_IDENTIFY_LOCATION
        || activityData.type === ACTIVITY_TYPE_BRAND_RACE
        || activityData.type === ACTIVITY_TYPE_POKER
        || activityData.type === ACTIVITY_TYPE_GUESS
        || activityData.type === ACTIVITY_TYPE_VISITOR_OPINION
        || activityData.type === ACTIVITY_TYPE_EXTERNAL_GAMES
      );

    let endDateError = null;
    if (showPredictionEndDate) {
      if (!endAtA) {
        endDateError = <FormattedMessage id='generic.validation.required'/>;
      } else if (!DateTimeHelper.isDateAfter(endAtA, startAt)) {
        endDateError = <FormattedMessage id='activity.manage.endDateAfterStartDate'/>;
      }
    }

    let consumableDaysError = false;
    let startDateError = null;
    let winnersByValueError = null;
    if (showValidationMsg) {
      if (!startAt) {
        startDateError = <FormattedMessage id='generic.validation.required'/>;
      } else if (!activityData.noEditStartAt && !DateTimeHelper.isDateAfter(startAt, this.dateNow)) {
        startDateError = <FormattedMessage id='activity.manage.startDateAfterCurrentDate'/>;
      }
      if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
        if ((!winnersByValue && winnersByValue !== 0) || ValueHelper.getEnglishValue(winnersByValue) < 0 || ValueHelper.getEnglishValue(winnersByValue) > activityData.questions.length) {
          winnersByValueError = <FormattedMessage id='activity.validationBetween' values={{value1: 0, value2: activityData.questions.length}}/>;
        }
      }
      if (activityData.type === constants.activity.types.SHOWCASE_MENU) {
        if (!endAt) {
          endDateError = <FormattedMessage id='generic.validation.required'/>;
        }
        if (!consumableWSunday && !consumableWMonday && !consumableWTuesday && !consumableWWednesday
          && !consumableWThursday && !consumableWFriday && !consumableWSaturday) {
          consumableDaysError = <FormattedMessage id='activity.selectDay'/>;
        }
      }
    }

    return (
      <div>
        <div className={classes.viewColumnFullWidthNoCenter} style={{maxWidth: FORM_WIDE_MAX_WIDTH}}>
          <FullWidthDummyView/>

          {this.getGamePlayImages()}

          {showBgAudioPicker ?
            <React.Fragment>
              <SectionHeaderView labelId={'activity.bgAudio'} />
              {this.getBgAudioView(0)}
              <FieldSpace multiplier={2}/>
            </React.Fragment>
            : null
          }

          <SectionHeaderView labelId={activityData.type === constants.activity.types.SHOWCASE_MENU ? 'activity.campaignDateTime' : 'activity.campaignStart'} />
          <div style={{marginLeft: -8, marginTop: -16}}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
              <div className={isXS ? classes.flexColumnNoCenter : classes.flexRowWrap}>
                <div style={{flex: 1, minWidth: 190, marginLeft: 8, marginTop: 16}}>
                  <DateTimePicker
                    inputVariant="filled"
                    variant="inline"
                    size="small"
                    fullWidth
                    autoOk
                    required={!activityData.noEditStartAt}
                    disablePast
                    InputProps={{disableUnderline: true}}
                    format="DD/MM/YYYY hh:mm A"
                    disabled={activityData.noEditStartAt}
                    id="startAt"
                    name="startAt"
                    invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                    maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    label={<FormattedMessage id='activity.manage.startDate'/>}
                    minDate={this.dateNow}
                    maxDate={this.dateMax}
                    value={startAt}
                    onChange={(date) => {
                      this.updateState({showValidationMsg: false, startAt: date})
                    }}
                    keyboardbuttonprops={{
                      'aria-label': 'change date',
                    }}
                    error={startDateError}
                    helperText={startDateError}
                  />
                </div>
                {activityData.type === constants.activity.types.SHOWCASE_MENU ?
                  <div style={{flex: 1, minWidth: 190, marginLeft: 8, marginTop: 16}}>
                    <DateTimePicker
                      inputVariant="filled"
                      variant="inline"
                      size="small"
                      fullWidth
                      autoOk
                      required
                      disablePast
                      InputProps={{disableUnderline: true}}
                      format="DD/MM/YYYY hh:mm A"
                      id="endAt"
                      name="endAt"
                      invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                      maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                      minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                      label={<FormattedMessage id='activity.endDate'/>}
                      minDate={startAt}
                      value={endAt}
                      onChange={(date) => {
                        this.updateState({showValidationMsg: false, endAt: date})
                      }}
                      keyboardbuttonprops={{
                        'aria-label': 'change date',
                      }}
                      error={endDateError}
                      helperText={endDateError}
                    />
                  </div>
                  : null
                }
              </div>
            </MuiPickersUtilsProvider>
          </div>
          <FieldSpace multiplier={activityData.type === constants.activity.types.SHOWCASE_MENU ? 1 : 1.5}/>

          {activityData.type === constants.activity.types.SHOWCASE_MENU ?
            <div className={classes.formActivityWide}>
              <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
                <div className={classes.viewRowFullWidth}>
                  <TimePicker
                    inputVariant="filled"
                    variant="inline"
                    size="small"
                    fullWidth
                    autoOk
                    format="hh:mm A"
                    id="hourStartAt"
                    name="hourStartAt"
                    invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                    maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    label={<FormattedMessage id='activity.manage.startTime'/>}
                    // minDate={this.dateNow}
                    value={hourStartAt}
                    onChange={(date) => {
                      this.updateState({showValidationMsg: false, hourStartAt: date})
                    }}
                    keyboardbuttonprops={{
                      'aria-label': 'change time',
                    }}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: hourStartAt ? (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              this.updateState({showValidationMsg: false, hourStartAt: null})
                            }}
                            onMouseDown={() => {
                              this.updateState({showValidationMsg: false, hourStartAt: null})
                            }}
                            edge="end">
                            <CancelIcon />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                  <Space vertical={16}/>
                  <TimePicker
                    inputVariant="filled"
                    variant="inline"
                    size="small"
                    fullWidth
                    autoOk
                    format="hh:mm A"
                    id="hourEndAt"
                    name="hourEndAt"
                    invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                    maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                    label={<FormattedMessage id='activity.manage.endTime'/>}
                    // minDate={hourStartAt ? hourStartAt : this.dateNow}
                    value={hourEndAt}
                    onChange={(date) => {
                      this.updateState({showValidationMsg: false, hourEndAt: date})
                    }}
                    keyboardbuttonprops={{
                      'aria-label': 'change time',
                    }}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: hourEndAt ? (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              this.updateState({showValidationMsg: false, hourEndAt: null})
                            }}
                            onMouseDown={() => {
                              this.updateState({showValidationMsg: false, hourEndAt: null})
                            }}
                            edge="end"
                          >
                            <CancelIcon />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
              <FormHelperText><FormattedMessage id={'activity.timeOptional'}/></FormHelperText>
              <FieldSpace multiplier={1.2}/>

              <div className={classes.flexRow}>
                <FormControl component="fieldset">
                  <FormLabel color={'secondary'}>
                    <FormattedMessage id='activity.weekDays'/>
                  </FormLabel>
                  <FormGroup row={true} >
                    <FormControlLabel
                      control={<Checkbox name={"consumableWSunday"} checked={consumableWSunday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='sunday'/>}
                    />
                    <FormControlLabel
                      control={<Checkbox name={"consumableWMonday"} checked={consumableWMonday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='monday'/>}
                    />
                    <FormControlLabel
                      control={<Checkbox name={"consumableWTuesday"} checked={consumableWTuesday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='tuesday'/>}
                    />
                    <FormControlLabel
                      control={<Checkbox name={"consumableWWednesday"} checked={consumableWWednesday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='wednesday'/>}
                    />
                    <FormControlLabel
                      control={<Checkbox name={"consumableWThursday"} checked={consumableWThursday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='thursday'/>}
                    />
                    <FormControlLabel
                      control={<Checkbox name={"consumableWFriday"} checked={consumableWFriday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='friday'/>}
                    />
                    <FormControlLabel
                      control={<Checkbox name={"consumableWSaturday"} checked={consumableWSaturday} onChange={this.onChecked} />}
                      label={<FormattedMessage id='saturday'/>}
                    />
                  </FormGroup>
                  {consumableDaysError ? <FormHelperText className={classes.helperError}>{consumableDaysError}</FormHelperText> : null}
                </FormControl>
              </div>
              <FieldSpace multiplier={1.5}/>
            </div>
            : null
          }

          <div className={classes.formActivity}>
            {showPredictionEndDate ?
              <React.Fragment>
                <FieldSpace/>
                <SectionHeaderView labelId={'activity.predictionValidity'} subLabelId={'activity.predictionDateHint'}/>
                <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
                  <div className={classes.viewColumnFullWidthNoCenter}>
                    <DateTimePicker
                      inputVariant="filled"
                      variant="inline"
                      size="small"
                      fullWidth
                      autoOk
                      required
                      disablePast
                      InputProps={{disableUnderline: true}}
                      format="DD/MM/YYYY hh:mm A"
                      id="endAt"
                      name="endAt"
                      invalidDateMessage={<FormattedMessage id='generic.invalidDateFormat'/>}
                      maxDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                      minDateMessage={<FormattedMessage id='generic.invalidDate'/>}
                      label={<FormattedMessage id='activity.predictionEndDate'/>}
                      minDate={startAt}
                      value={endAtA}
                      onChange={(date) => {
                        this.updateState({showValidationMsg: false, endAtA: date})
                      }}
                      keyboardbuttonprops={{
                        'aria-label': 'change date',
                      }}
                      error={endDateError}
                      helperText={endDateError}
                    />
                  </div>
                </MuiPickersUtilsProvider>
                <FieldSpace />
              </React.Fragment>
              : null
            }

            {showAnswerResult ?
              <React.Fragment>
                <FieldSpace/>
                <div className={classes.viewRowNoCenter}>
                  <div style={{marginBottom: -SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE}}>
                    <SectionHeaderView labelId={'activity.showAnswerDistribution'} subLabelId={'activity.showAnswerDistributionSubTitle'}/>
                  </div>
                  <Switch
                    checked={showAnswers}
                    onChange={this.onChecked}
                    id="showAnswers"
                    name="showAnswers"
                    color="primary"
                  />
                </div>
                <FieldSpace />
              </React.Fragment>
              : null
            }

            {activityData.type === constants.activity.types.QUESTIONNAIRE ?
              <React.Fragment>
                <FieldSpace />
                <SectionHeaderView labelId={'activity.questionnaireConfigs'} />
                <TextField
                  variant="filled"
                  fullWidth
                  size="small"
                  type="number"
                  id="winnersByValue"
                  name="winnersByValue"
                  label={<FormattedMessage id={'activity.correctAnswersCount'} />}
                  value={winnersByValue}
                  InputProps={{disableUnderline: true}}
                  inputProps={{min: 0, max: activityData.questions.length}}
                  onChange={this.onChange}
                  onKeyDown={textFieldIntegerOnKeyDown}
                  error={winnersByValueError}
                  helperText={winnersByValueError || <FormattedMessage id={'activity.correctAnswersCountHint'} values={{value: activityData.questions.length}} />}
                />
                <FieldSpace />

                {/*<TextField*/}
                {/*  variant="filled"*/}
                {/*  fullWidth*/}
                {/*  size="small"*/}
                {/*  type="number"*/}
                {/*  id="gameTime"*/}
                {/*  name="gameTime"*/}
                {/*  InputProps={{disableUnderline: true}}*/}
                {/*  label={<FormattedMessage id={'activity.gameTimeInSecs'} />}*/}
                {/*  value={gameTime}*/}
                {/*  inputProps={{min: 0, max: 3600}}*/}
                {/*  onChange={this.onChange}*/}
                {/*  onKeyDown={textFieldIntegerOnKeyDown}*/}
                {/*  helperText={<FormattedMessage id='activity.hintGameTime' />}*/}
                {/*/>*/}
                {/*<FieldSpace />*/}

                <div className={classes.viewRowNoCenter}>
                  <div style={{marginBottom: -SECTION_HEADER_WITH_SUBTITLE_BOTTOM_SPACE}}>
                    <SectionHeaderView labelId={'activity.showCheckRightOption'} subLabelId={'activity.showCheckRightOptionHint'}/>
                  </div>
                  <Switch
                    checked={correction}
                    onChange={this.onChecked}
                    id="correction"
                    name="correction"
                    color="primary"
                  />
                </div>
                <FieldSpace />
              </React.Fragment>
              : null
            }

            {/*{showFeedback ?*/}
            {/*  <div className={classes.viewColumnFullWidthNoCenter} style={{}}>*/}
            {/*    {this.getImage2View(FIELD_SPACE)}*/}

            {/*    <TextField*/}
            {/*      variant="filled"*/}
            {/*      fullWidth*/}
            {/*      multiline*/}
            {/*      rows={1}*/}
            {/*      rowsMax={8}*/}
            {/*      size="small"*/}
            {/*      type="text"*/}
            {/*      id="feedbackHint"*/}
            {/*      name="feedbackHint"*/}
            {/*      label={<FormattedMessage id={'activity.manage.feedbackAbout'} />}*/}
            {/*      InputProps={{disableUnderline: true}}*/}
            {/*      inputProps={{maxLength: 200}}*/}
            {/*      value={feedbackHint}*/}
            {/*      onChange={this.onChange}*/}
            {/*    />*/}
            {/*    <Space horizontal={FIELD_SPACE}/>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}

            {/*{showValuePlaceholders ?*/}
            {/*  <div className={classes.container}>*/}
            {/*    <div className={classes.flexRowNoCenter}>*/}
            {/*      <div className={classes.flex1}>*/}
            {/*        <TextField*/}
            {/*          variant="filled"*/}
            {/*          fullWidth*/}
            {/*          size="small"*/}
            {/*          type="text"*/}
            {/*          id="value1Placeholder"*/}
            {/*          name="value1Placeholder"*/}
            {/*          label={<FormattedMessage id={value1TextKey} />}*/}
            {/*          InputProps={{disableUnderline: true}}*/}
            {/*          inputProps={{maxLength: valueLength}}*/}
            {/*          value={value1Placeholder}*/}
            {/*          onChange={this.onChange}*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*    <Space horizontal={inputSpace}/>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}

            {/*{showParticipateLimit ?*/}
            {/*  <div className={classes.container}>*/}
            {/*    <TextField*/}
            {/*      variant="filled"*/}
            {/*      fullWidth*/}
            {/*      size="small"*/}
            {/*      type="number"*/}
            {/*      id="clickLimit"*/}
            {/*      name="clickLimit"*/}
            {/*      label={<FormattedMessage id='activity.manage.participantsLimit' />}*/}
            {/*      value={clickLimit}*/}
            {/*      InputProps={{disableUnderline: true}}*/}
            {/*      inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX}}*/}
            {/*      onChange={this.onChange}*/}
            {/*      onKeyDown={textFieldIntegerOnKeyDown}*/}
            {/*      helperText={<FormattedMessage id='activity.manage.leaveEmptyUnlimited'/>}*/}
            {/*    />*/}
            {/*    <Space horizontal={inputSpace}/>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}
            {/*{showContactNumber ?*/}
            {/*  <div className={classes.container}>*/}
            {/*    <TextField*/}
            {/*      variant="filled"*/}
            {/*      fullWidth*/}
            {/*      size="small"*/}
            {/*      type="text"*/}
            {/*      id="contactNumber"*/}
            {/*      name="contactNumber"*/}
            {/*      label={<FormattedMessage id='activity.manage.contactNumber'/>}*/}
            {/*      value={contactNumber}*/}
            {/*      InputProps={{disableUnderline: true}}*/}
            {/*      inputProps={{maxLength: 20}}*/}
            {/*      onChange={this.onChange}*/}
            {/*    />*/}
            {/*    <Space horizontal={inputSpace}/>*/}
            {/*  </div>*/}
            {/*  : null*/}
            {/*}*/}

            {activityData.type === constants.activity.types.SLIDES
              || activityData.type === constants.activity.types.SHOWCASE_MENU
              || activityData.type === constants.activity.types.JACKPOT
              || activityData.type === constants.activity.types.GAME_ROULETTE
              || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
              || activityData.type === constants.activity.types.GAME_BRAND_RACE
              || activityData.type === constants.activity.types.GAME_POKER
              || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
              || activityData.type === constants.activity.types.GAME_PUZZLE
              || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
              || activityData.type === constants.activity.types.GAME_FLIP_CARD
              || activityData.type === constants.activity.types.GAME_MATCH_PAIR
              || activityData.type === constants.activity.types.GAME_MATCH_THREE
              || activityData.type === constants.activity.types.GAME_BETTING_PIC
              || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
              || activityData.type === constants.activity.types.GUESS
              || activityData.type === constants.activity.types.IDENTIFY_LOCATION
              || activityData.type === constants.activity.types.PREDICTION
              || activityData.type === constants.activity.types.EXTERNAL_GAMES ?
              <React.Fragment>
                <FieldSpace multiplier={0.5}/>
                <SectionHeaderView labelId={'activity.chooseThemeColor'}/>
                <div style={{backgroundColor: ColorFieldBorder, borderRadius: BORDER_RADIUS, borderColor: ColorFieldBorder, borderWidth: 1, width: 227, padding: 1, overflow: 'hidden'}}>
                  <ChromePicker
                    disableAlpha
                    color={this.state.themeColor}
                    onChangeComplete={this.onColorPicked }
                    styles={{'default': {picker: {borderRadius: BORDER_RADIUS, boxShadow: null, overflow: 'hidden'}}}}/>
                </div>
                <FieldSpace multiplier={1.5}/>
              </React.Fragment>
              : null
            }

            {canEnableShowcase
              && activityData.type !== constants.activity.types.OFFER
              && activityData.type !== constants.activity.types.VOUCHER
              && activityData.type !== constants.activity.types.QUESTION
              && activityData.type !== constants.activity.types.VISITOR_OPINION
              && activityData.type !== constants.activity.types.QUESTIONNAIRE
              && activityData.type !== constants.activity.types.SURVEY
              && (activityData.type !== constants.activity.types.EXTERNAL_GAMES || activityData.gameInfo.autoSimulation)
              && activityData.type !== constants.activity.types.SHOWCASE_MENU
              && activityData.type !== constants.activity.types.GUESS
              && activityData.type !== constants.activity.types.IDENTIFY_LOCATION
              && activityData.type !== constants.activity.types.PREDICTION
              && activityData.type !== constants.activity.types.CHALLENGE
              ?
              <React.Fragment>
                <div className={classes.viewRowNoCenter} style={{marginTop: isXS ? FIELD_SPACE_XS : FIELD_SPACE}}>
                  <div className={classes.viewColumn}>
                    <SectionHeaderView
                      labelId={'activity.showcaseCampaign'}
                      // subLabelId={this.props.isEditing ? 'activity.showcaseCampaignHint1Edit' : 'activity.showcaseCampaignHint1'}
                      subLabelId={'activity.showcaseCampaignHint3'}
                      noBottomSpace={true}/>
                    {/*<TextView color={ColorOrange} variant={'caption'}>*/}
                    {/*  <FormattedMessage id={this.props.isEditing ? 'activity.showcaseCampaignHint2Edit': 'activity.showcaseCampaignHint2'}/>*/}
                    {/*</TextView>*/}
                  </div>
                  <Switch
                    checked={showcase}
                    onChange={this.onChecked}
                    id="showcase"
                    name="showcase"
                    color="primary"
                  />
                </div>
                <FieldSpace multiplier={1}/>
              </React.Fragment>
              : null
            }
          </div>
        </div>
        {this.renderSnackBar()}
      </div>
    )
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {snackbarMessageId, snackbarMessage, snackbarType} = snackbarInfo;
      const onClose = () => {
        this.setState({showSnackbar: false, snackbarInfo: null});
      };
      let message = snackbarMessage;
      if (!message && snackbarMessageId) {
        message = <FormattedMessage id={snackbarMessageId}/>;
      }
      return (
        <Snackbar open={message != null} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={onClose}>
          <MuiAlert severity={snackbarType || "success"} onClose={onClose} elevation={6} variant="filled">
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  getFormSectionHeaderView(section) {
    const {classes} = this.props;
    return (
      <FormSectionHeaderView classes={classes} section={section} onToggle={this.onFormSectionToggle} />
    );
  }

  onColorPicked = (color) => {
    this.updateState({themeColor: color.hex});
  };

  getGamePlayImages() {
    const {activityData, app, classes, isXS} = this.props;
    const showSlot = activityData.type !== constants.activity.types.SLIDES
      && activityData.type !== constants.activity.types.SHOWCASE_MENU
      && this.slotMaxImages > 0;
    const showGameImageUrl1 = activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
      || activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      // || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.COLLECT_STARS;
    const showGameImageUrl2 = activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER;

    if (!showSlot && !showGameImageUrl1 && !showGameImageUrl2) {
      return null;
    }
    let count = 0;
    if (showSlot) {
      count = this.slotMaxImages;
    }
    if (showGameImageUrl1) {
      count++;
    }
    if (showGameImageUrl2) {
      count++;
    }

    const spacing = isXS ? SPACE_IMAGE_XS : SPACE_IMAGE;
    return (
      <div className={classes.viewColumn} style={{marginLeft: !app.isLTR ? -12 : 0, marginRight: app.isLTR ? -12 : 0}}>
        <SectionHeaderView labelId={'activity.gamePlayImages'} />
        <div className={classes.viewFullWidthWrap}>
          {showGameImageUrl2 ?
            this.getImage2PickerView(0)
            : null
          }
          {showGameImageUrl1 ?
            this.getImage1PickerView(0)
            : null
          }
          {showSlot ?
            this.getSlotValuesView()
            : null
          }
        </div>
        <Space top={-spacing} />
        <FieldSpace multiplier={2}/>
      </div>
    );
  }

  getImage1PickerView(space = FIELD_SPACE) {
    const {activityData, app, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let isRequired = false;
    let size = isXS ? 'xsmall' : 'small';
    let imagePlaceholderId = null;
    let detailPlaceholderId = 'activity.manage.placeholderImageDescription';
    if (activityData.type === constants.activity.types.PREDICTION) {
      imagePlaceholderId = 'activity.manage.prediction1Image';
      previewImage = require('src/images/img_ph_1.png');
      detailPlaceholderId = 'activity.manage.placeholderImagePrediction1';
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      imagePlaceholderId = 'activity.manage.identifyLocationImage';
      detailPlaceholderId = 'activity.locationImageDesc';
    } else if (activityData.type === constants.activity.types.GAME_PUZZLE) {
      imagePlaceholderId = 'activity.manage.puzzleImage';
      previewImage = require('src/images/img_ph_p.png');
    } else if (activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      imagePlaceholderId = 'activity.manage.puzzleImage';
      previewImage = require('src/images/img_ph_p.png');
    } else if (activityData.type === constants.activity.types.LIKE_USER) {
      imagePlaceholderId = 'activity.manage.sharePlaceholderImage';
      previewImage = require('src/images/img_ph_1.png');
    } else {
      imagePlaceholderId = 'activity.manage.cardPlaceholderImage';
      previewImage = require('src/images/img_ph_f.png');
    }
    const maxWidthHeight = (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) ? IMAGE_MAX_WIDTH_HEIGHT : IMAGE_PROFILE_MAX_WIDTH_HEIGHT;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }
    const spacing = isXS ? SPACE_IMAGE_XS : SPACE_IMAGE;

    return (
      <div style={{marginLeft: !app.isLTR ? spacing : 0, marginRight: app.isLTR ? spacing : 0, marginBottom: spacing}}>
        <SingleFilePicker
          key={'SFP1'}
          required={isRequired}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_IMAGE_MIMES}
          maxFileSize={IMAGE_MAX_SIZE}
          maxWidthOrHeight={maxWidthHeight}
          aspectRatio={1}
          initialFiles={this.initialFiles1}
          onError={this.onErrorFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'imageUrl1');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'imageUrl1');
          }}
          error={error != null}
          errorText={error}
        />
      </div>
    );
  }

  getImage2PickerView(space = FIELD_SPACE) {
    const {activityData, app, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let imagePlaceholderId = null;
    let showLabelInner = false;
    let detailPlaceholderId = 'activity.manage.placeholderImageDescription';
    if (activityData.type === constants.activity.types.VISITOR_OPINION) {
      imagePlaceholderId = 'activity.manage.opinionImage';
      showLabelInner = true;
    } else  if (activityData.type === constants.activity.types.PREDICTION) {
      imagePlaceholderId = 'activity.manage.prediction2Image';
      previewImage = require('src/images/img_ph_2.png');
      detailPlaceholderId = 'activity.manage.placeholderImagePrediction2';
    } else if (activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
      imagePlaceholderId = 'activity.manage.imageToBeDiscovered';
      previewImage = require('src/images/img_ph_b.png');
    }
    const showCardUI = !previewImage;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }
    const spacing = isXS ? SPACE_IMAGE_XS : SPACE_IMAGE;

    return (
      <div style={{marginLeft: !app.isLTR ? spacing : 0, marginRight: app.isLTR ? spacing : 0, marginBottom: spacing}}>
        <SingleFilePicker
          key={'SFP2'}
          label={showLabelInner ? this.context.intl.formatMessage({id: imagePlaceholderId}) : null}
          required={false}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_IMAGE_MIMES}
          maxFileSize={IMAGE_MAX_SIZE}
          maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
          aspectRatio={1}
          initialFiles={this.initialFiles2}
          onError={this.onErrorFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'imageUrl2');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'imageUrl2');
          }}
          error={error != null}
          errorText={error}
        />
      </div>
    );
  }

  getImage2View(space = FIELD_SPACE) {
    const {activityData, classes, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let imagePlaceholderId = null;
    let showLabelInner = false;
    let detailPlaceholderId = 'activity.manage.placeholderImageDescription';
    if (activityData.type === constants.activity.types.VISITOR_OPINION) {
      imagePlaceholderId = 'activity.manage.opinionImage';
      showLabelInner = true;
    } else  if (activityData.type === constants.activity.types.PREDICTION) {
      imagePlaceholderId = 'activity.manage.prediction2Image';
      previewImage = require('src/images/img_ph_2.png');
      detailPlaceholderId = 'activity.manage.placeholderImagePrediction2';
    } else if (activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER) {
      imagePlaceholderId = 'activity.manage.imageToBeDiscovered';
      previewImage = require('src/images/img_ph_b.png');
    }
    const showCardUI = !previewImage;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }

    if (showCardUI) {
      return (
        <div className={classes.viewColumn}>
          {!showLabelInner && imagePlaceholderId ?
            <div className={classes.viewRow}
                 style={{alignItems: 'flex-end', padding: 6, paddingTop: 0, paddingBottom: 2}}>
              <InputLabel>{this.context.intl.formatMessage({id: imagePlaceholderId})}</InputLabel>
            </div>
            : null
          }
          <SingleFilePicker
            key={'SFP2'}
            label={showLabelInner ? this.context.intl.formatMessage({id: imagePlaceholderId}) : null}
            required={false}
            hideDropzoneText={true}
            filesLimit={1}
            showPreviewsInDropzone={true}
            acceptedFiles={ACCEPTED_IMAGE_MIMES}
            maxFileSize={IMAGE_MAX_SIZE}
            maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
            aspectRatio={1}
            initialFiles={this.initialFiles2}
            onError={this.onErrorFiles}
            onChange={(files) => {
              this.onChangeFiles(files, 'imageUrl2');
            }}
            onDelete={(file) => {
              this.onDeleteFile(file, 'imageUrl2');
            }}
            error={error != null}
            errorText={error}
          />
          <Space horizontal={space}/>
        </div>
      );
    }

    return (
      <div className={classes.imageCustomise} key={'SFPW2'}>
        <div className={classes.flexRow}>
          {/*<img className={classes.imageCustomisePlaceholderImage} src={previewImage}/>*/}
          {/*<Space verticalSpace={1}/>*/}
          <div className={classes.flexColumnNoCenter}>
            <Typography variant="body1" color={'textSecondary'}>
              {this.context.intl.formatMessage({id: imagePlaceholderId})}
            </Typography>
            <Typography variant="caption" color={'textSecondary'}>
              {<FormattedMessage id={detailPlaceholderId} />}
            </Typography>
          </div>
          <Space verticalSpace={1.5}/>
          <div style={{margin: -4}}>
            <SingleFilePicker
              key={'SFP2'}
              label={showLabelInner ? this.context.intl.formatMessage({id: imagePlaceholderId}) : null}
              required={false}
              hideDropzoneText={true}
              size={isXS ? 'xsmall' : 'small'}
              filesLimit={1}
              showPreviewsInDropzone={true}
              acceptedFiles={ACCEPTED_IMAGE_MIMES}
              maxFileSize={IMAGE_MAX_SIZE}
              maxWidthOrHeight={IMAGE_MAX_WIDTH_HEIGHT}
              aspectRatio={1}
              initialFiles={this.initialFiles2}
              onError={this.onErrorFiles}
              onChange={(files) => {
                this.onChangeFiles(files, 'imageUrl2');
              }}
              onDelete={(file) => {
                this.onDeleteFile(file, 'imageUrl2');
              }}
              error={error != null}
              errorText={error}
            />
          </div>
        </div>
      </div>
    );
  }

  getImage1View(space = FIELD_SPACE) {
    const {activityData, classes, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let isRequired = false;
    let size = isXS ? 'xsmall' : 'small';
    let imagePlaceholderId = null;
    let detailPlaceholderId = 'activity.manage.placeholderImageDescription';
    if (activityData.type === constants.activity.types.PREDICTION) {
      imagePlaceholderId = 'activity.manage.prediction1Image';
      previewImage = require('src/images/img_ph_1.png');
      detailPlaceholderId = 'activity.manage.placeholderImagePrediction1';
    } else if (activityData.type === constants.activity.types.IDENTIFY_LOCATION) {
      imagePlaceholderId = 'activity.manage.identifyLocationImage';
      detailPlaceholderId = 'activity.locationImageDesc';
    } else if (activityData.type === constants.activity.types.GAME_PUZZLE || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
      imagePlaceholderId = 'activity.manage.puzzleImage';
      previewImage = require('src/images/img_ph_p.png');
    } else if (activityData.type === constants.activity.types.LIKE_USER) {
      imagePlaceholderId = 'activity.manage.sharePlaceholderImage';
      previewImage = require('src/images/img_ph_1.png');
    } else {
      imagePlaceholderId = 'activity.manage.cardPlaceholderImage';
      previewImage = require('src/images/img_ph_f.png');
    }
    const maxWidthHeight = (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) ? IMAGE_MAX_WIDTH_HEIGHT : IMAGE_PROFILE_MAX_WIDTH_HEIGHT;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }

    return (
      <div className={classes.imageCustomise} key={'SFPW1'}>
        <div className={classes.flexRow}>
          {/*{previewImage ?*/}
          {/*  <img className={classes.imageCustomisePlaceholderImage} src={previewImage}/>*/}
          {/*  : <div className={classes.imageCustomisePlaceholderIcon} style={{backgroundColor: ColorFieldBorder}}>*/}
          {/*    <PhotoIcon style={{color:  ColorFieldBorderHover}} />*/}
          {/*  </div>*/}
          {/*}*/}
          {/*<Space verticalSpace={1}/>*/}
          <div className={classes.flexColumnNoCenter}>
            <Typography variant="body1" color={'textSecondary'}>
              {this.context.intl.formatMessage({id: imagePlaceholderId})}
            </Typography>
            <Typography variant="caption" color={'textSecondary'}>
              {<FormattedMessage id={detailPlaceholderId} />}
            </Typography>
          </div>
          <Space verticalSpace={1.5}/>
          <div style={{margin: -4}}>
            <SingleFilePicker
              key={'SFP1'}
              required={isRequired}
              hideDropzoneText={true}
              size={size}
              filesLimit={1}
              showPreviewsInDropzone={true}
              acceptedFiles={ACCEPTED_IMAGE_MIMES}
              maxFileSize={IMAGE_MAX_SIZE}
              maxWidthOrHeight={maxWidthHeight}
              aspectRatio={1}
              initialFiles={this.initialFiles1}
              onError={this.onErrorFiles}
              onChange={(files) => {
                this.onChangeFiles(files, 'imageUrl1');
              }}
              onDelete={(file) => {
                this.onDeleteFile(file, 'imageUrl1');
              }}
              error={error != null}
              errorText={error}
            />
          </div>
        </div>
      </div>
    );
  }

  getBgAudioView(space = FIELD_SPACE) {
    const {activityData, app, isXS} = this.props;
    const {showValidationMsg} = this.state;
    let previewImage = null;
    let isRequired = false;
    let size = isXS ? 'xsmall' : 'small';
    let imagePlaceholderId = 'activity.manage.bgAudio';
    const maxWidthHeight = (activityData.type === constants.activity.types.PREDICTION
      || activityData.type === constants.activity.types.IDENTIFY_LOCATION
      || activityData.type === constants.activity.types.LIKE_USER
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) ? IMAGE_MAX_WIDTH_HEIGHT : IMAGE_PROFILE_MAX_WIDTH_HEIGHT;

    let error = null;
    if (showValidationMsg) {
      if (!this.isFieldImageUrl1Correct()) {
        error = this.context.intl.formatMessage({id: 'generic.validation.required'});
      }
    }
    const spacing = isXS ? SPACE_IMAGE_XS : SPACE_IMAGE;

    return (
      <div style={{marginLeft: !app.isLTR ? spacing : 0, marginRight: app.isLTR ? spacing : 0}}>
        <SingleFilePicker
          key={'SFP1'}
          required={isRequired}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          showPreviewsInDropzone={true}
          acceptedFiles={ACCEPTED_AUDIO_MIMES}
          maxFileSize={AUDIO_MAX_SIZE}
          maxDuration={this.maxBgAudioDuration}
          initialFiles={this.bgAudioInitialFiles}
          onError={this.onErrorFiles}
          onChange={(files) => {
            this.onChangeFiles(files, 'bgAudioUrl');
          }}
          onDelete={(file) => {
            this.onDeleteFile(file, 'bgAudioUrl');
          }}
          error={error != null}
          errorText={error}
        />
      </div>
    );
  }

  getContainerMaxWidth() {
    const {activityData} = this.props;
    let maxPossibleWidth = FORM_INNER_WIDE_MAX_WIDTH;
    if (activityData.type === constants.activity.types.PREDICTION) {
      maxPossibleWidth = FORM_INNER_X_WIDE_MAX_WIDTH;
    }
    return Math.min(window.appWidth, maxPossibleWidth);
  }

  getMaxWidth() {
    // const {activityData, isXS} = this.props;
    // let maxPossibleWidth = window.appWidth;
    // if (!isXS) {
    //   maxPossibleWidth = FORM_INNER_WIDE_MAX_WIDTH;
    //   if (activityData.type === constants.activity.types.PREDICTION) {
    //     maxPossibleWidth = 680;
    //   } else if (activityData.type === constants.activity.types.VISITOR_OPINION) {
    //     maxPossibleWidth = FORM_INNER_MAX_WIDTH;
    //   } else if (activityData.type === constants.activity.types.LIKE_USER
    //     || activityData.type === constants.activity.types.COLLECT_STARS
    //     || activityData.type === constants.activity.types.JACKPOT
    //     || activityData.type === constants.activity.types.GAME_ROULETTE
    //     || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    //     || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
    //     || activityData.type === constants.activity.types.GAME_BETTING_PIC
    //     || activityData.type === constants.activity.types.GAME_FLIP_CARD
    //     || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
    //     || activityData.type === constants.activity.types.GAME_MATCH_PAIR
    //     || activityData.type === constants.activity.types.GAME_MATCH_THREE
    //     || activityData.type === constants.activity.types.GAME_PUZZLE
    //     || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
    //     || activityData.type === constants.activity.types.GAME_BRAND_RACE
    //     || activityData.type === constants.activity.types.GAME_POKER
    //     || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE) {
    //     maxPossibleWidth = 400;
    //   }
    // }
    return VIEW_BESIDE_PREVIEW_MAX_WIDTH;
  }

  isSlotsIncorrect() {
    return !this.slotValues || this.slotValues.length < this.slotMinValues; // || this.slotValues.length > this.slotMaxValues;
  }

  getSlotValuesView() {
    const {classes, activityData} = this.props;
    const views = [];
    for (let i = 0; i < this.slotMaxImages; i++) {
      views.push(this.getSlotValueView(i, this.slotValues[i]));
    }
    if (activityData.type === constants.activity.types.GAME_WHAC_A_MOLE && this.slotValues.length > this.slotTotalImages) {
      for (let i = this.slotTotalImages; i < this.slotValues.length; i++) {
        views.push(this.getSlotValueView(i, this.slotValues[i], i > 0 ? this.slotValues[i - 1] : null));
      }
    }
    return views;
  }

  getSlotValueView(optionIndex, item) {
    const {activityData, app, isXS} = this.props;
    const {showValidationMsg} = this.state;

    let isPlaceholderImageRequired = false;
    if (activityData.type === constants.activity.types.GAME_FLIP_CARD
      || activityData.type === constants.activity.types.GAME_FIND_HIDDEN
      || activityData.type === constants.activity.types.GAME_MATCH_PAIR
      || activityData.type === constants.activity.types.GAME_MATCH_THREE
      || activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
      || activityData.type === constants.activity.types.GAME_POKER
      || activityData.type === constants.activity.types.GAME_WHAC_A_MOLE
      || activityData.type === constants.activity.types.GAME_BRAND_RACE
      || activityData.type === constants.activity.types.GAME_PUZZLE
      || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE
      || activityData.type === constants.activity.types.GAME_GREEDY_SPIN
      || activityData.type === constants.activity.types.GAME_BETTING_PIC
      || activityData.type === constants.activity.types.GAME_ROULETTE
      || activityData.type === constants.activity.types.GAME_SPIN_N_DISCOVER
    ) {
      if (activityData.type === constants.activity.types.GAME_TIC_TAC_TOE
        || activityData.type === constants.activity.types.GAME_PUZZLE
        || activityData.type === constants.activity.types.GAME_PUZZLE_SLIDE) {
        isPlaceholderImageRequired = false;
      }
    }

    let imageLabelId = null;
    let imageSrc = null;
    if (optionIndex === 2) {
      imageLabelId = 'activity.manage.gamePlayImage3';
      // imageSrc = require('src/images/img_ph_3.png');
    } else if (optionIndex === 1) {
      imageLabelId = 'activity.manage.gamePlayImage2';
      // imageSrc = require('src/images/img_ph_2.png');
    } else {
      imageLabelId = 'activity.manage.gamePlayImage1';
      // imageSrc = require('src/images/img_ph_1.png');
      if (this.slotTotalImages === 1) {
        imageLabelId = 'activity.manage.gamePlayImage';
      }
    }

    const spacing = isXS ? SPACE_IMAGE_XS : SPACE_IMAGE;
    return (
      <div style={{marginLeft: !app.isLTR ? spacing : 0, marginRight: app.isLTR ? spacing : 0, marginBottom: spacing}}>
        <SingleFilePicker
          key={this.key +'-slot-'+ optionIndex} // added to reload ui and correctly putting the images in multiple slots
          id={this.key +'-slot-'+ optionIndex}
          name={this.key +'-slot-'+ optionIndex}
          // label={placeholderLabel}
          required={isPlaceholderImageRequired}
          hideDropzoneText={true}
          size={'xsmall'}
          filesLimit={1}
          acceptedFiles={ACCEPTED_IMAGE_MIMES}
          maxFileSize={IMAGE_MAX_SIZE}
          maxWidthOrHeight={IMAGE_PROFILE_MAX_WIDTH_HEIGHT}
          aspectRatio={1}
          initialFiles={item.initialFiles}
          error={showValidationMsg && !item.imageUrl && (!item.imageFiles || item.imageFiles.length === 0)}
          errorText={showValidationMsg && !item.imageUrl && (!item.imageFiles || item.imageFiles.length === 0) ? <FormattedMessage id='generic.validation.required' /> : null}
          onChange={(files) => {
            this.onChangeSlotFiles(files, optionIndex);
          }}
          onDelete={(file) => {
            this.onDeleteSlotFile(file, optionIndex);
          }}
        />
      </div>
    );
  }

  isValueCorrect(value) {
    return value && parseInt(ValueHelper.getEnglishValue(value)) >= 0;
  }

  onAddNewSlotValueClicked = () => {
    if (!this.slotValues) {
      this.slotValues = [];
    }
    this.slotValues.push({
      points: '0',
      value1: this.getRandomWeightage(),
      winLimit: this.slotValues.length === 0 ? '1' : '0',
      winILimit: '0',
      imageUrl: null,
      initialFiles: [],
    });
    this.reloadView();
  };

  onCenterChanged = (data) => {
    let {latitude, longitude} = this.state;
    if (data) {
      latitude = data.center.lat;
      longitude = data.center.lng;
    }
    this.updateState({
      latitude: latitude,
      longitude: longitude,
      rightOptionHint: ''+ latitude,
      rightOptionHintAr: ''+ longitude,
    });
  };

  onSelectWinnersBySelected = (value) => {
    this.updateState({
      winnersBySelected: value.id,
      showValidationMsg: false,
      isBusinessLoading: false,
    });
  };

  onChangeSlotFiles(files, id) {
    let eImageUrl = this.slotValues[id].imageUrl;

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.slotValues[id].imageUrl = lFileUrl;
    this.slotValues[id].imageFiles = lFiles;
    this.reloadView();
  }

  onDeleteSlotFile(file, id) {
    let eImageUrl = this.slotValues[id].imageUrl;
    let eImageFiles = this.slotValues[id].imageFiles;

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      let index = 0;
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.slotValues[id].imageUrl = lFileUrl;
    this.slotValues[id].imageFiles = lFiles;
    this.slotValues[id].isImageDeleted = true;
    this.reloadView();
  }

  onErrorFiles = (error) => {
    this.showSnackbar({
      snackbarMessage: error,
      snackbarType: "error",
    });
  };

  onChangeFiles(files, id) {
    const {
      imageUrl1,
      imageUrl2,
      bgAudioUrl
    } = this.state;

    let eFileUrl = null;
    let keyFileUrl = null;
    let keyFiles = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eFileUrl)) {
          lFileUrl = eFileUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl1,
      imageFiles1,
      imageUrl2,
      imageFiles2,
      bgAudioUrl,
      bgAudioFiles,
    } = this.state;

    let eFileUrl = null;
    let eFiles = null;
    let keyFileUrl = null;
    let keyFiles = null;
    let keyIsFileDeleted = null;
    if (id === 'imageUrl1') {
      eFileUrl = imageUrl1;
      eFiles = imageFiles1;
      keyFileUrl = 'imageUrl1';
      keyFiles = 'imageFiles1';
      keyIsFileDeleted = 'isImageDeleted1';
    } else if (id === 'imageUrl2') {
      eFileUrl = imageUrl2;
      eFiles = imageFiles2;
      keyFileUrl = 'imageUrl2';
      keyFiles = 'imageFiles2';
      keyIsFileDeleted = 'isImageDeleted2';
    } else if (id === 'bgAudioUrl') {
      eFileUrl = bgAudioUrl;
      eFiles = bgAudioFiles;
      keyFileUrl = 'bgAudioUrl';
      keyFiles = 'bgAudioFiles';
      keyIsFileDeleted = 'isBgAudioDeleted';
    }

    let lFiles = [];
    let lFileUrl = eFileUrl;
    if (eFiles) {
      let index = 0;
      eFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
        index++;
      });
      lFiles = eFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eFileUrl)) {
      lFileUrl = null;
    }

    this.updateState({showValidationMsg: false, [keyFileUrl]: lFileUrl, [keyFiles]: lFiles, [keyIsFileDeleted]: true});
  }

  onChecked = (event) => {
    const value = event.target.checked;
    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

  onChange = (event) => {
    const {activityData} = this.props;
    let value = event.target.value;
    if (event.target.name === 'feedbackHint' || event.target.name === 'qTitle') {
      value = value.replace("\n", " ");
    } else if (event.target.name === 'winPoints'
      || event.target.name === 'winLimit'
      || event.target.name === 'winILimit'
      || event.target.name === 'clickLimit'
      || event.target.name === 'winnersByValue'
      || event.target.name === 'gameTime'
    ) {
      let maxValue = constants.activity.VALUE_DEFAULT_MAX;
      if (event.target.name === 'winnersByValue') {
        if (activityData.type === constants.activity.types.QUESTIONNAIRE) {
          maxValue = activityData.questions.length;
        }
      }
      value = ValueHelper.getDecimalValue(value);
      if (ValueHelper.getEnglishValue(value) < 0) {
        value = '0';
      } else if (ValueHelper.getEnglishValue(value) > maxValue) {
        value = maxValue;
      }
    }

    this.updateState({[event.target.name]: value, showValidationMsg: false});
  };

}

ManageActivityCustomization.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  app: PropTypes.object,
  activities: PropTypes.object,
  activityData: PropTypes.object,
  moveNextCallback: PropTypes.func.isRequired,
  onDataUpdated: PropTypes.func.isRequired,
};

ManageActivityCustomization.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
    activities: state.admin.activities,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isDrawerHidden', theme => theme.breakpoints.down('sm'), {defaultMatches: true}],
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
    ['isMD', theme => theme.breakpoints.down('md'), {defaultMatches: true}]
  ])(ManageActivityCustomization))
);
